import { Zap } from "lucide-react";

const ITEMS = [
  "Pronto intervento elettrico",
  "Apertura porte in emergenza",
  "Cancelli elettrici",
  "Roma e Provincia",
  "Attivi 24/7",
  "Preventivo immediato",
];

function Sequence({ ariaHidden }) {
  return (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-7 font-display text-lg font-bold uppercase tracking-wide text-black sm:text-xl">
            {item}
          </span>
          <Zap size={18} className="shrink-0 text-volt" fill="currentColor" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section aria-label="Servizi in sintesi" className="border-y border-line bg-ink/40 py-6">
      <div className="mask-fade-x overflow-hidden">
        <div className="flex w-max animate-marquee">
          <Sequence ariaHidden={false} />
          <Sequence ariaHidden={true} />
        </div>
      </div>
    </section>
  );
}
